module.exports = __webpack_public_path__ + "static/media/lemobs.5f763b25.svg";